import { render } from "./acceptReceipt.vue?vue&type=template&id=4a3b91c2&scoped=true"
import script from "./acceptReceipt.vue?vue&type=script&lang=js"
export * from "./acceptReceipt.vue?vue&type=script&lang=js"

import "./acceptReceipt.vue?vue&type=style&index=0&id=4a3b91c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3b91c2"]])

export default __exports__